import type { components, paths } from "@/api/schema.ts";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/ky.ts";
import { getApiUrl } from "@/api/utils.ts";

export const CODE_LISTS_KEY = "codeLists";

export type CodeListsResponse = components["schemas"]["CodeLists"];
type CodeListsInput = paths["/code-lists"]["get"]["parameters"]["query"];

export function useCodeListsQuery(
  params: CodeListsInput,
  options?: Omit<UseQueryOptions<CodeListsResponse, HTTPError>, "queryFn" | "queryKey">,
) {
  return useQuery<CodeListsResponse, HTTPError>({
    queryKey: [CODE_LISTS_KEY],
    queryFn: () =>
      api
        .get(getApiUrl("/code-lists") + "/", {
          searchParams: params.codeListCodes.map((value) => `codeListCodes=${value}`).join("&"),
        })
        .json(),
    ...options,
  });
}
